import { vitalsIcon } from '../../../common/Icons';
import {
    FETCH_STATE,
    LoaderWithText,
    RefreshWithErrorText,
} from '../../../common/PatientOverviewUtils';

const vitalIcon = vitalsIcon('fill-white');

export const VitalsEmptyCard: React.FC<{ fetchState?: FETCH_STATE; onRefresh?: () => void }> = ({
    fetchState,
    onRefresh,
}) => (
    <section className="flex flex-col h-full font-lato bg-white text-14 pb-16">
        <div className="sticky top-0 flex items-center px-16 py-6 space-x-8 border-b border-neutral-8 bg-white">
            <div className="flex justify-center items-center w-24 h-24 rounded-4 bg-darwin-accent-symptoms-blue-800">
                {vitalIcon}
            </div>
            <p className="font-700">Vitals</p>
        </div>
        <div className="pb-26 flex-1 grid place-content-center text-center">
            <div className="w-160 h-155 overflow-hidden m-auto">
                <img src="/images/Lab-Vitals.png" alt="medical records" />
            </div>
            <p className="font-700 mt-20 mb-18 h-24">
                {fetchState === FETCH_STATE.FETCHING ? (
                    <LoaderWithText text="Fetching vitals" />
                ) : fetchState === FETCH_STATE.ERROR ? (
                    <RefreshWithErrorText text="Error in Fetching vitals" onRefresh={onRefresh} />
                ) : (
                    'No Vitals Added!'
                )}
            </p>
            <p className="text-darwin-neutral-600 mx-15 max-w-304">
                Whenever you add vitals for the patient, you will see vitals per prescription here
            </p>{' '}
        </div>
    </section>
);
